module.exports = __webpack_public_path__ + "img/shan.9b1ffcfd.jpg";